import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { StyleSheet, css } from 'aphrodite';
// import { Link } from 'react-router-dom';
import { Theme } from '../../config/theme';

import UserImage from '../UserImage';

export default class Reviews extends Component {
  render() {
    return (
      <span>
        {
          this.props.isPublic ? (
            <div className={css(styles.review)}>
              <div className={css(styles.review_author)}>
                <a href={this.props.profileLink}>
                  <UserImage
                    image={this.props.photo}
                    styles={styles.review_photo}
                  />
                </a>
                <div className={css(styles.review_details)}>
                  <div className={css(styles.review_name)}>{this.props.name}</div>
                  <div className={css(styles.review_date)}>{this.props.date}</div>
                </div>
              </div>
              <div className={css(styles.review_content)}>
                {this.props.children}
              </div>
            </div>
          ) : false
        }
      </span>
    );
  }
}

Reviews.defaultProps = {};

Reviews.propTypes = {
  photo: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  profileLink: PropTypes.string.isRequired,
  children: PropTypes.string.isRequired,
  isPublic: PropTypes.bool.isRequired,
};

const styles = StyleSheet.create({
  review: {
    display: 'flex',
    alignItems: 'flex-start',
    padding: '25px 20px',
    color: '#000e1f',
    fontSize: 15,
    fontFamily: Theme.font_family_primary,
    fontWeight: Theme.font_weight_primary,
    backgroundColor: '#f5f5f5',
    border: '1px solid #ddd',

    [Theme.mobile_query]: {
      flexDirection: 'column',
    },

    ':not(:last-child)': {
      borderBottom: 0,
    },
  },
  review_author: {
    display: 'flex',
    alignItems: 'center',
  },
  review_photo: {
    height: 50,
    width: 50,
    marginRight: 15,
    flexShrink: 0,
  },
  review_details: {
    flexShrink: 0,
  },
  review_name: {
    marginBottom: 8,
    fontSize: 15,
  },
  review_date: {
    fontSize: 14,
    color: '#828282',
  },
  review_content: {
    position: 'relative',
    paddingTop: 3,
    paddingBottom: 7,
    fontSize: 15,
    paddingLeft: 80,
    lineHeight: 1.53,
    letterSpacing: 0.3,

    [Theme.mobile_query]: {
      paddingLeft: 0,
      paddingTop: 15,
    },

    ':not(.fish) > p': {
      fontSize: 15,

      [Theme.mobile_query]: {
        fontSize: 14,
      },

      ':not(:last-child)': {
        marginBottom: 15,
      },
    },
  },
});



// WEBPACK FOOTER //
// ./src/components/Review/index.js